export const RESUME_URL = 'https://drive.google.com/file/d/15VPe7hnRL0vtsfNYZ4KFgJbFUD1DS2wC/view?usp=drive_link';
export const ART_PATH = '/art';
export const WRITING_PATH = '/writing';
export const NOTEBOOK_PATH = '/notebook';

export const navLinks = [
  { label: 'About', id: 'about', kind: 'scroll' },
  { label: 'Projects', id: 'project', kind: 'scroll' },
  { label: 'Skills', id: 'skill', kind: 'scroll' },
  { label: 'Contact', id: 'contact', kind: 'scroll' },
];

export const secondaryLinks = [
  { label: 'Art', id: 'art', kind: 'route', path: ART_PATH },
  { label: 'Writing', id: 'writing', kind: 'route', path: WRITING_PATH },
];

export const SOCIAL_LINKS = {
  github: 'https://github.com/developer8HARSHAL',
  linkedin: 'https://www.linkedin.com/in/harshal-pinge-ab13b5216/',
  email: 'mailto:harshalpinge@gmail.com',
};
